import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';


const skills = [
  { name: 'Python', weight: 3, categories: ['AI/Data', 'Programming'] },
  { name: 'JavaScript', weight: 2, categories: ['Programming'] },
  { name: 'TypeScript', weight: 2, categories: ['Programming'] },

  { name: 'Selenium', weight: 2, categories: ['DevOps'] },
  { name: 'Langchain', weight: 2, categories: ['AI/Data'] },


  { name: 'Pandas', weight: 3, categories: ['Programming'] },
  { name: 'Grafana', weight: 2, categories: ['AI/Data', 'Misc'] },
  { name: 'GitLab', weight: 2, categories: ['DevOps', 'Cloud'] },
  { name: 'Terraform', weight: 3, categories: ['DevOps', 'Cloud'] },
  { name: 'CDK', weight: 2, categories: ['DevOps', 'Cloud'] },
  { name: 'Ansible', weight: 2, categories: ['DevOps', 'Programming'] },
  { name: 'Rundeck', weight: 2, categories: ['DevOps', 'Misc'] },
  { name: 'AWS', weight: 3, categories: ['Cloud']},
  { name: 'Azure', weight: 2, categories: ['Cloud']},

  { name: 'CICD', weight: 2, categories: ['DevOps'] },
  { name: 'Shell', weight: 2, categories: [ 'Programming'] },
  { name: 'GIT', weight: 2, categories: ['DevOps'] },
  { name: 'Linux', weight: 3, categories: ['DevOps','Misc'] },
  { name: 'Nginx', weight: 2, categories: ['DevOps'] },
  { name: 'Airflow', weight: 2, categories: ['DevOps', 'AI/Data'] },
  { name: 'Tensorflow', weight: 2, categories: [ 'AI/Data'] },
  { name: 'Nifi', weight: 3, categories: ['AI/Data'] },
  { name: 'Fluentbit', weight: 2, categories: ['AI/Data'] },
  { name: 'Kafka', weight: 2, categories: [ 'AI/Data'] },
  { name: 'Open Shift', weight: 2, categories: ['DevOps', 'Misc'] },
  { name: 'Artifactory', weight: 1, categories: ['DevOps'] },
  { name: 'Puppet', weight: 1, categories: ['DevOps'] },
  { name: 'Helm', weight: 1, categories: ['DevOps', 'Programming'] },
  { name: 'Ansible Tower', weight: 2, categories: ['DevOps', 'Misc'] },
  { name: 'SQL', weight: 3, categories: ['Programming'] },
  { name: 'Traefik', weight: 2, categories: ['DevOps'] },
  { name: 'Java', weight: 2, categories: [ 'Programming'] },
  { name: 'FastAPI', weight: 3, categories: [ 'Programming'] },
];

const SkillsList = ({ selectedCategories }) => {
  return (
    <Box sx={{ mt: 4, border:'1px solid #ddd',borderRadius: '8px',padding: '10px 20px',backgroundColor:'#ffffff' }}>

        <Box
            sx={{
              display: 'flex',
              gap: 2, // Space between items
              alignItems: 'center',
              mt: 1, // Margin-top for spacing from "Skills/Tools:"
              mb: 3,
              flexWrap: 'wrap',
            }}
          >
            <Typography variant="h6" color="primary"  >
                Skills/Tools:
              </Typography>
            <Typography sx={{fontWeight: 900,
                            color: 'primary.main',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.2)'}}>
                              Expert  
            </Typography>
            <Typography sx={{fontWeight: 600,
                            color: '#757575',
                            textShadow: 'none'}}>
                              Professional 
            </Typography>
            <Typography sx={{fontWeight: 300,
                            color: '#757575',
                            textShadow: 'none'}}>
                              Basic 
            </Typography>
        </Box>
      
      <Grid container spacing={2}>
        {skills
          .filter((skill) =>
            selectedCategories.length === 0
              ? true
              : skill.categories.some((cat) => selectedCategories.includes(cat))
          )
          .map((skill) => (
            <Grid item key={skill.name}>
              <Box
                sx={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  backgroundColor: '#f4f4f9',
                  textAlign: 'center',
                  border: '1px solid #ddd',
                }}
              >
                <Typography sx={{fontWeight: skill.weight * 300,
                        color: skill.weight === 3 ? 'primary.main' : '#757575',
                        textShadow: skill.weight === 3 ? '1px 1px 2px rgba(0,0,0,0.2)' : 'none'
                    }}>
                    {skill.name}
                </Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

// PropTypes for validation
SkillsList.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SkillsList;
